import React, { useEffect } from 'react';
import { ClipboardList, CheckCircle, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RoofQuiz } from '../components/RoofQuiz';
import { businessInfo } from '../mockData';

export const FreeAssessmentPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = "Free Roof Assessment Quiz | Dezire Metal Roofing Sydney";
  }, []);

  const handleQuizClose = () => {
    // Navigate to book inspection page
    navigate('/book-inspection');
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/zrqyrs2h_b1af1cf4-190b-4caf-945d-73d8591fc9b9.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 mb-4 px-4 py-2 bg-primary/20 border border-primary/30 rounded-full">
              <ClipboardList className="w-5 h-5 text-primary" />
              <span className="text-primary font-semibold">2-Minute Assessment</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Free <span className="text-primary">Roof Assessment</span> Quiz
            </h1>
            <p className="text-xl text-gray-300 mb-6">
              Answer a few quick questions about your roof and get personalized recommendations from our experts.
            </p>
            
            {/* Benefits */}
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <CheckCircle className="w-5 h-5 text-primary" />
                <span className="text-white">Instant Results</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <CheckCircle className="w-5 h-5 text-primary" />
                <span className="text-white">Expert Recommendations</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <CheckCircle className="w-5 h-5 text-primary" />
                <span className="text-white">No Obligation</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quiz Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <RoofQuiz onClose={handleQuizClose} />
          </div>
        </div>
      </section>

      {/* Alternative CTA */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Prefer to Speak to Someone?
            </h2>
            <p className="text-gray-600 mb-6">
              Our friendly team is ready to help. Call us now for a free consultation.
            </p>
            <a
              href="/call"
              className="inline-flex items-center space-x-3 bg-primary hover:bg-accent text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all"
            >
              <Phone className="w-6 h-6" />
              <span>Call: {businessInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
